const styles = () => ({
  navIcon: {
    width: 22,
    display: 'flex',
    justifyContent: 'center',
  },
});

export default styles;
